var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentPeopleQueue20Regular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M6.5 7.5a2.25 2.25 0 1 0 0-4.5a2.25 2.25 0 0 0 0 4.5m0-1a1.25 1.25 0 1 1 0-2.5a1.25 1.25 0 0 1 0 2.5M3 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.5a3.5 3.5 0 1 1-7 0zm1 0v4.5a2.5 2.5 0 0 0 5 0V9zm5.626-2.857a3.234 3.234 0 0 1-.396.87c.413.048.787.22 1.084.48a2.25 2.25 0 1 0-1.127-4.07c.193.282.342.597.439.934a1.25 1.25 0 1 1 0 1.787m-.127 10.712A3.5 3.5 0 0 0 14 13.5V9a1 1 0 0 0-1-1h-2.267c.17.294.268.636.268 1h2v4.5a2.5 2.5 0 0 1-2.75 2.488c-.213.32-.465.611-.75.867m4.127-10.712a3.236 3.236 0 0 1-.396.87c.413.048.787.22 1.084.48a2.25 2.25 0 1 0-1.127-4.07c.193.282.342.597.439.934a1.25 1.25 0 1 1 0 1.787m-.127 10.712A3.5 3.5 0 0 0 18 13.5V9a1 1 0 0 0-1-1h-2.267c.17.294.268.636.268 1h2v4.5a2.5 2.5 0 0 1-2.75 2.488c-.213.32-.465.611-.75.867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentPeopleQueue20Regular);
export default __webpack_public_path__ + "static/media/fluent--people-queue-20-regular.7bc68cd5c3c1c9ba7a0952358804daea.svg";
export { ForwardRef as ReactComponent };